import React from 'react';
import {
  DietSettingsConnectorApollo,
  DietSettingsValidateConnectorApollo,
  DietGenerateConnectorApollo,
  SaveUserDataConnectorApollo,
  DietIdEnum,
  DietModeType,
} from '@front-activerse/common-components';
import DietSettingsContainer from './DietSettingsContainer';
import { IRoute } from '@front-activerse/common-components';
import { stepConfigItem } from './types';
import DietSettingsQuery from './graphql/DietSettingsQuery';
import DietGenerateMutation from './graphql/DietGenerateMutation';
import ValidationQuery from './graphql/ValidationQuery';
import { useAppContext } from '@front-activerse/common-components';
interface IDietSettingsPage {
  descendantRoutes: IRoute[];
  stepsSchema: stepConfigItem[];
  currentMainStep: string;
  dietTypes: {
    id: number;
    value: DietIdEnum;
    optionTitle: string;
    optionDescription: string;
  }[];
  dietLevels?: {
    id: number;
    value: DietIdEnum;
    optionTitle: string;
    optionDescription: string;
  }[];
  dietModes?: {
    value: DietModeType;
    optionTitle: string;
    optionDescription: string;
  }[];
}

const DietSettingsIndexPage: React.FC<IDietSettingsPage> = ({
  descendantRoutes,
  stepsSchema,
  currentMainStep,
  dietTypes,
  dietLevels,
  dietModes,
}) => {
  const { post } = useAppContext();

  return (
    <DietSettingsConnectorApollo query={DietSettingsQuery}>
      {({ ...dietSettingsData }) => (
        <DietGenerateConnectorApollo mutation={DietGenerateMutation} post={post}>
          {({ generateDiet }) => (
            <SaveUserDataConnectorApollo>
              {({ saveUserData }) => (
                <DietSettingsValidateConnectorApollo query={ValidationQuery}>
                  {({ validateDietSettings }) => (
                    <DietSettingsContainer
                      descendantRoutes={descendantRoutes}
                      {...dietSettingsData}
                      generateDiet={generateDiet}
                      saveUserData={saveUserData}
                      validateDietSettings={validateDietSettings}
                      stepsSchema={stepsSchema}
                      currentMainStep={currentMainStep}
                      key={currentMainStep}
                      dietTypes={dietTypes}
                      dietLevels={dietLevels}
                      dietModes={dietModes}
                    />
                  )}
                </DietSettingsValidateConnectorApollo>
              )}
            </SaveUserDataConnectorApollo>
          )}
        </DietGenerateConnectorApollo>
      )}
    </DietSettingsConnectorApollo>
  );
};

export default DietSettingsIndexPage;
